import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

import logo from "images/yenimahalle/yenimahalle_logo.png";
import { FaFacebookF, FaInstagram, FaPhone, FaFax, FaTwitter, FaYoutube } from "react-icons/fa";

/* ---------- Stil tanımları ---------- */

const Container = tw.div`relative bg-gray-200 -mx-8 -mb-8 px-8`;

const ThreeColumns = tw.div`
  max-w-screen-xl mx-auto pt-16 lg:pt-20
  flex flex-col md:flex-row md:justify-between md:px-8
`;

const Column = tw.div`
  w-full md:w-1/3
  text-center md:text-left
`;

const ColumnHeading = tw.h5`font-bold mt-5`;
const LinkList = tw.ul`mt-4 text-sm font-medium`;
const LinkListItem = tw.li`mt-3 flex items-center justify-center md:justify-start`;
const Link = tw.a`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black text-primary-500`;

const SocialLinksContainer = tw.div`mt-4`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900 transition duration-300 mr-4`}
  svg { ${tw`w-4 h-4`} }
`;

/* Çerez metni için tek satırlık yardımcı bileşen */
const CookieNotice = tw.p`text-xs text-gray-600 text-center py-8 mb-4`;

/* ---------- Bileşen ---------- */

export default function Footer() {
  return (
    <Container>
      <ThreeColumns>
        {/* 1. Kolon */}
        <Column>
          <LogoContainer>
            <LogoImg src={logo} alt="Yenimahalle Belediyesi" />
            <LogoText>Yenimahalle Belediyesi</LogoText>
          </LogoContainer>

          <SocialLinksContainer>
            <SocialLink href="https://www.facebook.com/YenimahalleBelediyesi"><FaFacebookF /></SocialLink>
            <SocialLink href="https://x.com/yenimahallebld"><FaTwitter /></SocialLink>
            <SocialLink href="https://www.youtube.com/watch?v=wYJGSYKd9rs"><FaYoutube /></SocialLink>
            <SocialLink href="https://www.instagram.com/yenimahallebelediyesi/?hl=en"><FaInstagram /></SocialLink>
          </SocialLinksContainer>

          <LinkList>
            <LinkListItem>
              Yenimahalle Belediye Başkanlığı<br />
              İvedik Caddesi No: 25<br />
              Yenimahalle / ANKARA
            </LinkListItem>
          </LinkList>
        </Column>

        {/* 2. Kolon */}
        <Column>
          <LinkList>
            <LinkListItem><Link href="/Icerik/vergi-odeme-noktalari/28">Ödeme Noktaları</Link></LinkListItem>
            <LinkListItem><Link href="https://ebelediye.yenimahalle.bel.tr/" target="_blank" rel="noopener noreferrer">Sicil Arama</Link></LinkListItem>
            <LinkListItem><Link href="https://ebelediye.yenimahalle.bel.tr/Giris/Index/?returnURL=/Borc/Index" target="_blank" rel="noopener noreferrer">Hızlı Ödeme</Link></LinkListItem>
            <LinkListItem><Link href="/Icerik/pazar-yerleri/23">Pazar Yerleri</Link></LinkListItem>
            <LinkListItem><Link href="/Icerik/kvkk/44">KVKK</Link></LinkListItem>
          </LinkList>
        </Column>

        {/* 3. Kolon */}
        <Column>
          <LinkList>
            <LinkListItem><FaPhone tw="mr-2" /> 0 (312) 526 26 26</LinkListItem>
            <LinkListItem><FaFax tw="mr-2" /> 0 (312) 327 56 58</LinkListItem>
          </LinkList>

          <ColumnHeading>7/24 İletişim Hizmetleri</ColumnHeading>
          <LinkList>
            <LinkListItem>
              <FaPhone tw="mr-2" />
              <div>
                {/* <div>444 93 64</div>
                <div>(444 YENİ)</div> */}
                <div>0 (312) 870 11 11</div>
              </div>
            </LinkListItem>
          </LinkList>
        </Column>
      </ThreeColumns>

      {/* Kolonların altında tek satır çerez metni */}
      <CookieNotice>
        <strong>Çerez Bilgilendirmesi:</strong> yenimahalle.bel.tr ana internet sitesinde çerez kullanılmamaktadır. Zorunlu çerezler yalnızca form veya başvuru işlemlerinin yürütüldüğü alt sayfalarda, oturum yönetimi ve güvenlik amacıyla devreye girebilir.
      </CookieNotice>
    </Container>
  );
}
